import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as conversation from '../conversation'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: conversation.RESOURCE.payload.dimension.partialId,
      partialId: conversation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The ID of the user who owns this conversation.',
    isOptional: false,
    name: 'Owner ID',
    partialId: PartialId.Standard.create('owner_id'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
